import { render, staticRenderFns } from "./OrderField.vue?vue&type=template&id=da5e45e2"
import script from "./OrderField.vue?vue&type=script&lang=js"
export * from "./OrderField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports